// extracted by mini-css-extract-plugin
export default {"btn":"PrimaryBtn_btn__NLmZh"};